import { SelectFields } from '@repo/toolkit/types'

import { HostFamily } from '../../lib/types/models/host-family/host-family'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentHostFamily<T extends FieldsSelector<HostFamily>>(
  enrollmentId: number,
  fields: T
) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getEnrollmentHostFamily.url, { id: enrollmentId }),
        { fields }
      )
    )
    .get<SelectFields<HostFamily, T>>()
}
